import { arrangeEntries } from './scheduleOperations';
import { cleanParallel } from './scheduleTimeline';
import { isTime, isMealBreak } from './scheduleTimes';
export const unscheduledScenes = (scenes,days) => {
  const assigned=new Set(days.flatMap(d=>(d.entries||[]).filter(e=>e.kind==='scene').map(e=>e.sceneUid)));
  return scenes.filter(s=>!assigned.has(s.sceneUid));
};
// Shared lock check for a whole proposed arrangement (mirrors backend manual-schedule-protection).
export const lockViolation=(days,next)=>{
  // New insertions may precede locks; only pre-existing occurrences count as displacement.
  const previousIds=new Set(days.flatMap(d=>(d.entries||[]).map(e=>e.id)));
  for(const d of days) for(const [i,e] of (d.entries||[]).entries()) {
    if(!e.locked||isMealBreak(e))continue;
    const list=next.find(n=>n.dayNumber===d.dayNumber)?.entries||[],at=list.findIndex(x=>x.id===e.id),kept=list[at];
    if(!kept)return (`"${e.name||e.id}" is locked and cannot be removed or moved to another day. Unlock it first.`);
    if(kept.parallelGroupId!==e.parallelGroupId||kept.start!==e.start||kept.durationMin!==e.durationMin)return (`"${e.name||e.id}" is locked, so its start time and duration cannot change. Unlock it first.`);
    // A locked entry with a fixed start keeps its exact time wherever it sits in the order;
    // without a fixed start its time depends on position, so displacement stays protected.
    if(!isTime(e.start)&&list.slice(0,at).filter(x=>previousIds.has(x.id)).length>i)return (`"${e.name||e.id}" is locked without a fixed start time, so other entries cannot be moved ahead of it. Unlock it first.`);
  }
  return null;
};
// Returns {changes} for a valid move, or {error} with the specific reason it was rejected.
export const boardChange = (days,from,index,to,targetIndex,addition) => {
  const source=days.find(d=>d.dayNumber===from),target=days.find(d=>d.dayNumber===to);
  const entry=addition||source?.entries?.[index];
  if(!entry)return {error:'That entry is no longer there. Refresh and try again.'};
  if(entry.locked&&!isMealBreak(entry))return {error:`"${entry.name||'This entry'}" is locked. Unlock it before moving it.`};
  if(!target&&to!==null)return {error:'That shooting day is no longer there. Refresh and try again.'};
  const next=days.map(d=>({...d,entries:[...(d.entries||[])]}));
  if(!addition)next.find(d=>d.dayNumber===from)?.entries.splice(index,1);
  if(to!==null)next.find(d=>d.dayNumber===to)?.entries.splice(targetIndex,0,entry);
  for(const d of next) d.entries=cleanParallel(d.entries);
  const lockError=lockViolation(days,next);
  if(lockError)return {error:lockError};
  return {changes:next.filter(d=>d.dayNumber===from||d.dayNumber===to).map(d=>{
    const original=days.find(n=>n.dayNumber===d.dayNumber)?.entries||[];
    const entries=arrangeEntries(d.entries,true,original).map(e=>original.find(o=>o.id===e.id&&o.locked)||e);
    return {dayNumber:d.dayNumber,day:{...d,entries}};
  })};
};
export const changeBoard=(...args)=>boardChange(...args).changes||null;
